import React from "react";
// import { useMapContext } from "../core/MapContext";
import type { MapPlugin } from "./Plugin.types";
// import { useDispatch, useStore } from "react-redux";

export function PluginLoader({ plugin, ...props }: { plugin: MapPlugin | any } & Record<string, any>)
{
  // const { engine, pluginManager, mapType, mapInstance } = useMapContext();

  // const dispatch = useDispatch();
  // const store = useStore();

  // useEffect(() => {
  //   if (!engine || !pluginManager) return;

  //   const ctx = {
  //     mapType: mapType,
  //     mapInstance: mapInstance,
  //     dispatch: dispatch,
  //     getState: store.getState,
  //   };

  //   pluginManager.register(plugin, ctx);

  //   return () => {
  //     pluginManager.unregister(plugin.id, ctx);
  //   };
  // }, [plugin, mapType]);

  const Component = plugin.Component;

  return Component ? React.createElement(Component, props) : null;
}
